import { Box, Typography, CircularProgress, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  SearchInput,
  SelectableTable,
  DropdownFilter,
  Button,
  AccountDetails,
  ApamoveAccountsTable,
} from "../../components";
//import { usersData } from "./mock-data";
import { useState } from "react";
import { useStyles } from "./style";
import { PlusIcon } from "../../components/button/icons";
import { useGetAllUsers } from "../../service/api";
import { User } from "../../types";
import { highlightText } from "../../utils/highlight-text";

export const AccountManagement = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState<"apa" | "apamove">("apa");
  const [optionPeriod, setOptionPeriod] = useState("Current Month");
  const [optionAccount, setOptionAccount] = useState("Live");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedAccount, setSelectedAccount] = useState<User | null>(null);
  const [selectedRow, setSelectedRow] = useState<string | null>(null);

  const { data, error, isLoading } = useGetAllUsers();

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  const filteredData = Array.isArray(data)
    ? data.filter((user: User) => {
        return (
          user?.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user?.apaSerial?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          user?.phone?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          user?.subscription
            ?.toLowerCase()
            ?.includes(searchQuery.toLowerCase()) ||
          user?.status?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
          user?.usage?.toLowerCase()?.includes(searchQuery.toLowerCase())
        );
      })
    : [];


  const handleEditClick = (account: any) => {
    setSelectedAccount(account);
  };

  const handleCloseAccountDetails = () => {
    setSelectedAccount(null);
    setSelectedRow(null);
  };

  return (
    <Box className={classes.container}>
      <h1 className={classes.title}> {t("accountManagement.title")}</h1>

      <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} sx={{ minHeight: 36 }}>
        <Tab value="apa" label={t("accountManagement.apaTab")} sx={{ minHeight: 36 }} />
        <Tab value="apamove" label={t("accountManagement.apamoveTab")} sx={{ minHeight: 36 }} />
      </Tabs>

      {activeTab === "apamove" ? (
        <ApamoveAccountsTable />
      ) : (
      <Box className={classes.columnsWrapper}>
        {/* Left Column */}
        <Box className={classes.leftColumnWrapper}>
          <Box className={classes.innerContainer}>
            <Typography className={classes.accounts}>
              {t("accountManagement.accounts")}{" "}
              <span className={classes.accountsNum}>({filteredData.length})</span>
            </Typography>
            <Box className={classes.filters}>
              <DropdownFilter
                label={t("accountManagement.period")}
                options={["Current Month", "Last Month", "Last Year"]}
                selected={optionPeriod}
                onSelect={(option) => setOptionPeriod(option)}
              />
              <DropdownFilter
                label={t("accountManagement.accounts")}
                options={["Live", "Idle"]}
                selected={optionAccount}
                onSelect={(option) => setOptionAccount(option)}
              />

              {!selectedAccount && (
                <>
                  <Box style={{ marginLeft: "8px" }}>
                    <Button
                      color="primary"
                      icon={<PlusIcon width={16} height={16} />}
                    >
                      {t("accountManagement.addSubscriber")}
                    </Button>
                  </Box>
                  <SearchInput query={searchQuery} onSearch={handleSearch} />
                </>
              )}
            </Box>
          </Box>

          <Box>
            {isLoading || error ? (
              <Box className={classes.loadingAndErrorWrapper}>
                {isLoading ? (
                  <CircularProgress />
                ) : (
                  <Typography color="error">
                    {t("accountManagement.errorLoadingUsers")}
                  </Typography>
                )}
              </Box>
            ) : (
              <SelectableTable
                data={filteredData}
                query={searchQuery}
                highlightText={highlightText}
                onEditClick={handleEditClick}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                selectedAccount={selectedAccount}
                setSelectedAccount={setSelectedAccount}
              />
            )}
          </Box>
        </Box>

        {/* Right Column */}
        {selectedAccount && (
          <AccountDetails
            onClose={handleCloseAccountDetails}
            account={selectedAccount}
          />
        )}
      </Box>
      )}
    </Box>
  );
};
